module.exports = "/src/views/player/menu/elements/fractions/elements/tasks/images/4.png";